import React, { useContext, useEffect, useState } from "react";
import { BasicContext } from '../context/BasicContext'

export default () => {
    const bc = useContext(BasicContext)

    
    
    const menuOnline = [
        { menuMame: "法定必修課程", pid: "dahboard", bid:"legal", url: "./Course.html" },
        { menuMame: "銷售資格課程", pid: "list", bid:"identity",  url: "./Course.html?pid=list&Class2=B", class2: "B" },
        { menuMame: "專業課程", pid: "list", bid:"prof",  url: "./Course.html?pid=list&Class2=C", class2: "C" },
        { menuMame: "我的紀錄", pid: "state1", bid:"state1", url: "./Course.html?pid=state" }
    ]

    const menuOTS = [
        { menuMame: "活動報名", pid: "event",   bid:"event", class1: "A", url: "./Course.html?pid=event" },
        { menuMame: "課程報名", pid: "lession", bid:"lession", class1: "B", url: "./Course.html?pid=lession"},
        { menuMame: "我的紀錄", pid: "state2",  bid:"state2", class1: "",  url: "./Course.html?pid=state"},
    ]

    const [ActBtn, setActBtn] = useState<string>(bc.PID)

    /*
    const StateBtn = ()=> <button
        className={"hibBtn xl " + (ActBtn == "state" ? "active" : "")}
        //disabled={btn.disabled}
        onClick={() => {
            setActBtn("state")
            bc.setBID("state")
            bc.setPID("state")
            bc.setClass1("")
            bc.setActType("")
        }}
    >我的紀錄</button>
    */

    useEffect(() => {
        setActBtn(bc.BID)
    }, [bc])

    return (
        <div id="courseMenu">
            {
                ["event", "lession", "state2"].indexOf(bc.PID) > - 1?
                menuOTS.map((btn, index: number) => {
                    return (
                        <button
                            key={"menu" + index}
                            className={"hibBtn xl " + (btn.bid == ActBtn ? "active" : "")}
                            //disabled={btn.disabled}
                            onClick={() => {
                                setActBtn(btn.bid)
                                bc.setBID(btn.bid)
                                bc.setPID(btn.pid)
                                if (btn.class1) {
                                    bc.setClass1(btn.class1)
                                } else {
                                    bc.setClass1("")
                                }
                                bc.setActType("")
                            }}
                        >{btn.menuMame}</button>
                    )
                }):
                ["dahboard", "list", "state1"].indexOf(bc.PID) > - 1?
                menuOnline.map((btn, index: number) => {
                    return (
                        <button
                            key={"menu" + index}
                            className={"hibBtn xl " + (btn.bid == ActBtn ? "active" : "")}
                            onClick={() => {
                                setActBtn(btn.bid)
                                bc.setPID(btn.pid)
                                bc.setBID(btn.bid)
                                bc.setActType("")
                                if (btn.class2) {
                                    bc.setClass2(btn.class2)
                                } else {
                                    bc.setClass2("")

                                }
                            }}
                        >{btn.menuMame}</button>
                    )
                }):""
            }
        </div>
    )

    if (["event", "lession", "record"].indexOf(bc.PID) > - 1) {
        return (
            <div id="courseMenu">
                {
                    menuOTS.map((btn, index: number) => {
                        return (
                            <button
                                key={"menu" + index}
                                className={"hibBtn xl " + (btn.bid == ActBtn ? "active" : "")}
                                //disabled={btn.disabled}
                                onClick={() => {
                                    setActBtn(btn.bid)
                                    bc.setBID(btn.bid)
                                    bc.setPID(btn.pid)
                                    if (btn.class1) {
                                        bc.setClass1(btn.class1)
                                    } else {
                                        bc.setClass1("")
                                    }
                                    bc.setActType("")
                                }}
                            >{btn.menuMame}</button>
                        )
                    })
                }
            </div>
        )
    } else {
        return (
            <div id="courseMenu">
                {
                    menuOnline.map((btn, index: number) => {
                        return (
                            <button
                                key={"menu" + index}
                                className={"hibBtn xl " + (btn.bid == ActBtn ? "active" : "")}
                                onClick={() => {
                                    setActBtn(btn.bid)
                                    bc.setPID(btn.pid)
                                    bc.setBID(btn.bid)
                                    bc.setActType("")
                                    if (btn.class2) {
                                        bc.setClass2(btn.class2)
                                    } else {
                                        bc.setClass2("")

                                    }
                                }}
                            >{btn.menuMame}</button>
                        )
                    })
                }
            </div>
        )
    }
}

